import React from 'react'
import { Checkbox } from 'antd'

const CheckboxField = ({ label = 'Checkbox', value = false, onChange }) => {
  return (
    <div className="flex flex-col space-y-1">
      <Checkbox checked={value} onChange={onChange}>
        {label}
      </Checkbox>
    </div>
  )
}

export default CheckboxField
